import { API } from 'aws-amplify';
import { getRunDetail, echo } from '../../graphql/queries';

export async function updateRunFromRh(event_id, run_id) {
  //   console.log('updateRunFromRh', event_id, run_id);
  try {
    const apiData = await API.graphql({
      query: echo,
      variables: { event_id: Number(event_id), run_id: Number(run_id) },
    });
    const r = apiData.data.echo;
    const statusCode = r.statusCode;
    // const res = JSON.parse(r.body);
    // console.log(statusCode, res);
    return statusCode;
  } catch (error) {
    console.log(error);
    return error;
  }
}

export async function fetchRunDetails(event_id, run_id) {
  // check if run.status is PROVISIONAL or anything other than FINAL and then
  // update the Runtable from RaceHero (overwrite runJson).  Might also need to
  // check run.has_results === true
  // can check this from runIds in state
  // console.log(runIds);
  // runIds.forEach((run) => console.log(run.id));
  // const rundeets = runIds.filter((run) => run.id === Number(run_id));
  // if (!rundeets || rundeets[0].status !== 'FINAL') {
  //   console.log('do the thing to update the runJson from RaceHero');
  //   const raceHeroRunDetails = getRunDetails(eventId, run_id);
  //   setRhRunJson(raceHeroRunDetails); // cors issue
  //   await updateRunJson(raceHeroRunDetails);
  // }
  let r;
  try {
    const apiData = await API.graphql({
      query: getRunDetail,
      variables: { id: run_id },
    });
    r = apiData.data.getRunDetail;
    console.log(r);
    if (r === null) {
      console.log('we need to populate our DB with the event from RaceHero');
      const updateResponse = await updateRunFromRh(event_id, run_id);
      if (updateResponse === 200) {
        console.log(`statusCode: ${updateResponse}`);
        const apiDataRetry = await API.graphql({
          query: getRunDetail,
          variables: { id: run_id },
        });
        r = apiDataRetry.data.getRunDetail;
        // console.log(r);
      } else {
        console.log(`problem updating record. aborting`);
        return;
      }
    }
    const runResponse = r;
    // const runVersion = r._version;
    const runJson = JSON.parse(runResponse.runJson);
    return {
      eventId: runJson.event_id,
      runId: runJson.run_id,
      runJson: runJson,
    };
  } catch (error) {
    console.log(error);
  }
}

async function fetchRunDetails2(run_id) {
  try {
    const apiData = await API.graphql({
      query: getRunDetail,
      variables: { id: run_id },
    });
    const r = apiData.data.getRunDetail;
    const runJson = JSON.parse(r.runJson);
    return {
      eventId: runJson.event_id,
      runId: runJson.run_id,
      runJson: runJson,
    };
  } catch (error) {
    console.log(error);
  }
}
